import { apiRequest } from './api';

export interface LandingLot {
  id: string;
  slug: string;
  title: string;
  budgetUzs: number | null;
  deadline: string | null;
  regionName: string | null;
  categoryName: string | null;
  bidSecurityUzs: number | null;
  /** Опубликованная источником ставка обеспечения («3» = 3 %) или null — см.
   *  `bidSecurityPct` в catalog-client. Необязательное: payload API старше
   *  29.09.2026 его не несёт. */
  bidSecurityPct?: number | null;
}

export interface LandingCategory {
  slug: string;
  name: string;
  active: number;
}

export interface LandingNiche {
  key: string;
  categorySlug: string;
  active: number;
  lots: LandingLot[];
}

export interface LandingStats {
  generatedAt: string;
  activeTenders: number;
  newLastWeek: number;
  awardedTotal: number;
  participantRecords: number;
  ifiActive: number;
  sourceCount: number;
  /**
   * Регистраций без служебных аккаунтов, округлено ВНИЗ до сотни на сервере
   * (точное число публичный эндпоинт не отдаёт). Необязательное: payload API
   * старше 13.10.2026 его не несёт. Читать через `socialProofCount` — там
   * порог показа и защита от «более 0».
   */
  registeredUsersFloor?: number;
  topCategories: LandingCategory[];
  remainingCategories: number;
  niches: LandingNiche[];
  featuredLot: LandingLot | null;
  starterLot: LandingLot | null;
}

/**
 * Ключ запроса статистики лендингов.
 *
 * ⚠️ Пререндер сеет под ЭТОТ ключ (см. seedRouteQuery в entry-server.tsx).
 * Любое расхождение — молчаливый промах кэша: страница уезжает к боту пустой
 * оболочкой без единого числа, что выглядит ровно как упавший деплой.
 */
export function landingStatsQueryKey(locale: string): [string, string] {
  return ['landing-stats', locale];
}

/** Публичные живые данные обоих лендингов. */
export async function fetchLandingStats(lang: string): Promise<LandingStats> {
  return apiRequest<LandingStats>(`/catalog/landing-stats?lang=${lang}`);
}
